const getPaisFilterFields = () => [
  {
    name: 'id',
    label: 'ID',
    type: 'number',
  },
  {
    name: 'nome',
    label: 'Nome',
    initial: true,
  },
  {
    name: 'sigla',
    label: 'Sigla',
  },
  {
    name: 'codigo',
    label: 'Código',
    type: 'number',
  },
];

export default getPaisFilterFields;
